module.exports = __webpack_public_path__ + "img/no-permission.8c1f9add.png";